import ResponsiveModal from "@moneris-portal/responsive-modal";
import { SecondaryButton } from "@moneris-portal/button";
import connectionIcon from "../../../assets/connection_icon.svg";
import subscriptionIcon from "../../../assets/subscription_icon.svg";
import calendarIcon from "../../../assets/calendar_icon.svg";
import StatusChip from "../StatusChip";
import ManagePlanDropdown from "../Dropdown";
import Hook from "./useAccountSettingsSidebar";
import "./index.scss";

function AccountSettingsSidebar(props) {
  const {
    BLOCK,
    isOpen,
    isConnected,
    hasSubscription,
    isCancellationPending,
    subscriptionChipVariant,
    subscriptionLabel,
    planDisplayText,
    renewalDateText,
    handleClose,
    handleDisconnect,
    reconnectLink,
    translate,
  } = Hook.useAccountSettingsSidebar(props);

  return (
    <ResponsiveModal
      show={isOpen}
      onClose={handleClose}
      position="right"
      title={translate("title")}
      id="account_settings_sidebar"
    >
      <div className={BLOCK.current}>
        <div className={`${BLOCK.current}__section`}>
          <div className={`${BLOCK.current}__row`}>
            <img src={connectionIcon} alt="" aria-hidden="true" />
            <span>{translate("integrationStatus")}</span>
            <StatusChip
              status={isConnected ? "connected" : "disconnected"}
              label={
                isConnected ? translate("connected") : translate("inactive")
              }
            />
          </div>
          {isConnected && (
            <div className={`${BLOCK.current}__disconnect`}>
              <SecondaryButton
                clickHandler={handleDisconnect}
                title={translate("disconnectIntegration")}
              />
            </div>
          )}
          {!isConnected && (
            <div className={`${BLOCK.current}__reconnect`}>
              <a href={reconnectLink}>
                <SecondaryButton title={translate("reconnectIntegration")} />
              </a>
            </div>
          )}
        </div>

        {hasSubscription && (
          <>
            <div className={`${BLOCK.current}__section`}>
              <div className={`${BLOCK.current}__row`}>
                <img src={subscriptionIcon} alt="" aria-hidden="true" />
                <span>{translate("subscriptionPlan")}</span>
                <StatusChip
                  status={subscriptionChipVariant}
                  label={subscriptionLabel}
                />
              </div>
              <div className={`${BLOCK.current}__plan-details`}>
                <span className={`${BLOCK.current}__plan-text`}>
                  {planDisplayText}
                </span>
                <ManagePlanDropdown
                  isCancellationPending={isCancellationPending}
                />
              </div>
            </div>
            {renewalDateText && (
              <div className={`${BLOCK.current}__section`}>
                <div className={`${BLOCK.current}__row`}>
                  <img src={calendarIcon} alt="" aria-hidden="true" />
                  <span>{translate("renewalDate")}</span>
                </div>

                <div className={`${BLOCK.current}__date-value`}>
                  {renewalDateText}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </ResponsiveModal>
  );
}

export default AccountSettingsSidebar;
